export default "__VITE_ASSET__AhsAkRiE__"